import { z } from 'zod'

export const ZAirbridgeObject = z.object({
  category: z.string(),
  action: z.string().optional(),
  label: z.string().optional(),
  value: z.number().optional(),
  semanticAttributes: z.record(z.string(), z.unknown()).optional(),
  customAttributes: z.record(z.string(), z.unknown()).optional(),
})

export type TAirbridgeObject = z.infer<typeof ZAirbridgeObject>
